import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { notification, Switch, Popconfirm } from "antd";

import { getVendorList } from "../../redux/actions";
import { getFoodConfigAction, updateFoodConfigAction } from "../../redux/actions/foodConfigAction";
import { toggleVendorStatus } from "../../redux/actions/foodItemsAdminAction";
import { Loader } from "../svg";
import { foodVendor } from "../../asset";

const TAB_VENDORS = "vendors";
const TAB_SETTINGS = "settings";

const FoodOrdersListAdmin = ({
  vendorList,
  getVendorList,
  foodConfig,
  foodConfigLoading,
  getFoodConfigAction,
  updateFoodConfigAction,
  toggleVendorStatus,
}) => {
  const [activeTab, setActiveTab] = useState(TAB_VENDORS);
  const [limitInput, setLimitInput] = useState("");
  const [saving, setSaving] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getVendorList();
    getFoodConfigAction();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (foodConfig?.freeOrderDailyLimit !== undefined) {
      setLimitInput(String(foodConfig.freeOrderDailyLimit));
    }
  }, [foodConfig]);

  const handleSaveConfig = async () => {
    const val = parseInt(limitInput, 10);
    if (isNaN(val) || val <= 0) {
      notification.error({ message: "Please enter a valid positive number for the daily limit." });
      return;
    }
    setSaving(true);
    const result = await updateFoodConfigAction({ freeOrderDailyLimit: val });
    setSaving(false);
    if (result?.success) {
      notification.success({ message: "Food config updated successfully!" });
    } else {
      notification.error({ message: "Failed to update food config." });
    }
  };

  const onToggleVendor = async (e, element) => {
    e.stopPropagation(); // prevent card click navigation
    const result = await toggleVendorStatus(element.vendorId, element.status);
    if (result?.success) {
      notification.success({ message: `Vendor ${element.status === 1 ? 'disabled' : 'enabled'} successfully!` });
      getVendorList(); // Refresh list to show updated status
    } else {
      notification.error({ message: "Failed to update vendor status." });
    }
  };

  return (
    <div className="body_container cm_bold marginTop">
      {/* Tabs */}
      <div className="d-flex align-items-center mb-4" style={{ borderBottom: "2px solid #e0e0e0" }}>
        <button
          className={`btn btn-link mr-3 pb-2 ${activeTab === TAB_VENDORS ? "text-primary border-bottom border-primary" : "text-secondary"}`}
          style={{ fontWeight: 600, fontSize: 16, borderRadius: 0 }}
          onClick={() => setActiveTab(TAB_VENDORS)}
        >
          Vendors
        </button>
        <button
          className={`btn btn-link pb-2 ${activeTab === TAB_SETTINGS ? "text-primary border-bottom border-primary" : "text-secondary"}`}
          style={{ fontWeight: 600, fontSize: 16, borderRadius: 0 }}
          onClick={() => setActiveTab(TAB_SETTINGS)}
        >
          Settings
        </button>
      </div>

      {/* ── Vendors Tab ── */}
      {activeTab === TAB_VENDORS && (
        <>
          <h3 className="mb-4">VENDOR LIST</h3>
          <div className="vendorCardsDiv">
            {vendorList ? (
              vendorList.length > 0 ? (
                vendorList.map((element) => (
                  <div
                    key={element.vendorId}
                    className="col-xl-6 col-lg-6"
                    onClick={() => {
                      history.push(`/vendors/vendorOrders/${element.vendorId}`, {
                        vendorId: element.vendorId,
                        vendorName: element.name,
                      });
                      localStorage.setItem("vendorId", element.vendorId);
                    }}
                  >
                    <div className="cm_card card vendorCard" style={{ opacity: element.status === 1 ? 1 : 0.7 }}>
                      <div>
                        <img
                          src={element.image ? element.image : foodVendor}
                          alt="vendorImage"
                          className="vendorImage"
                        />
                      </div>
                      <div className="vendor-card-details-div w-100 pr-3">
                        <div className="d-flex justify-content-between align-items-start w-100">
                          <div>
                            <p className="blue mb-1">{element.name}</p>
                            <p className="green small mb-1">Phone no : {element.phoneNo}</p>
                            <p className="purple small mb-2">Email : {element.email}</p>
                          </div>
                          <div onClick={(e) => e.stopPropagation()}>
                            <Popconfirm
                              title={`Are you sure you want to ${element.status === 1 ? 'disable' : 'enable'} this vendor?`}
                              onConfirm={(e) => onToggleVendor(e, element)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <div className="d-flex flex-column align-items-center">
                                <Switch
                                  size="small"
                                  checked={element.status === 1}
                                  loading={false}
                                />
                                <span className="small mt-1" style={{ fontSize: 10 }}>
                                  {element.status === 1 ? 'Active' : 'Disabled'}
                                </span>
                              </div>
                            </Popconfirm>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                "No data available"
              )
            ) : (
              <Loader />
            )}
          </div>
        </>
      )}

      {/* ── Settings Tab ── */}
      {activeTab === TAB_SETTINGS && (
        <div style={{ maxWidth: 480 }}>
          <h5 className="mb-3">Food Order Settings</h5>
          {foodConfigLoading ? (
            <Loader />
          ) : (
            <>
              <div className="form-group">
                <label htmlFor="freeOrderDailyLimit" style={{ fontWeight: 500 }}>
                  Daily Free Order Limit (₹)
                </label>
                <p className="text-muted small mb-1">
                  Maximum total value of free orders an employee can place per day (8:30 AM–11:00 AM IST).
                  Contractual employees (type 5) are not eligible regardless.
                </p>
                <div className="d-flex align-items-center" style={{ gap: 12 }}>
                  <input
                    id="freeOrderDailyLimit"
                    type="number"
                    className="form-control"
                    style={{ width: 160 }}
                    value={limitInput}
                    min={1}
                    onChange={(e) => setLimitInput(e.target.value)}
                    placeholder="e.g. 30"
                  />
                  <button
                    className="btn btn-primary"
                    onClick={handleSaveConfig}
                    disabled={saving}
                  >
                    {saving ? "Saving…" : "Save"}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  vendorList: state.vendorList.data?.vendorList,
  foodConfig: state.foodConfig?.config,
  foodConfigLoading: state.foodConfig?.loading || false,
});

const mapDispatchToProps = (dispatch) => ({
  getVendorList: () => dispatch(getVendorList()),
  getFoodConfigAction: () => dispatch(getFoodConfigAction()),
  updateFoodConfigAction: (params) => dispatch(updateFoodConfigAction(params)),
  toggleVendorStatus: (id, status) => dispatch(toggleVendorStatus(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FoodOrdersListAdmin);
